import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Presenter from './Presenter'
import { endAllVotes } from '../../dataStore/slices/votes/votesSlice'
import selectPresentReady from '../../dataStore/selectors/selectPresentReady'
import { State } from '../../dataStore/reducers/reducerType'
import selectHasGigEnded from '../../dataStore/selectors/selectHasGigEnded'
import { PresenterProps } from './types'
import { qualityWarningActions } from '../../dataStore/slices/qualityWarning'


const mapStateToProps = (state: State): Omit<PresenterProps, 'history' | 'match' | 'onQualityWarningClose' | 'endAllVotes'> => ({
  isSidePanelOpen: state.ui.isSidePanelOpen,
  menuItemSelected: state.ui.menuItemSelected,
  isPresentReady: selectPresentReady(state),
  hasGigEnded: selectHasGigEnded(state),
  qualityWarning: !state.qualityWarning.closed ? state.qualityWarning.text : null,

})

const mapDispatchToProps = (dispatch): Pick<PresenterProps, 'endAllVotes' | 'onQualityWarningClose'> => ({
  endAllVotes: () => dispatch(endAllVotes()),
  onQualityWarningClose: () => dispatch(qualityWarningActions.close())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Presenter))
